/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useIsLoggedIn } from '../../hooks/common/use-is-logged-in'
import { usePathname } from 'next/navigation'

/** Routes that use the whole screen or belong to the login flow and therefore don't show the navigation sidebar */
const ROUTES_WITHOUT_SIDEBAR = ['/p', '/s', '/login', '/register', '/new-user', '/new']

/**
 * Determines if the navigation sidebar can be shown on the current page.
 * The sidebar is only available to logged-in users, since guests can't list notes.
 *
 * @return true if the sidebar can be shown
 */
export const useNoteTreeSidebarAvailable = (): boolean => {
  const isLoggedIn = useIsLoggedIn()
  const pathname = usePathname() ?? ''
  return isLoggedIn && !ROUTES_WITHOUT_SIDEBAR.some((route) => pathname === route || pathname.startsWith(`${route}/`))
}
